import type { FC, ReactNode, ComponentType, PropsWithChildren, JSX } from "react";

import styled from "styled-components";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import type { BadgeType } from "@similarweb/ui-components";
import { Badge, PlainTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { NoPrintContainer } from "app/components/layout/NoPrintContainer";

import { FlexRow } from "../../../styled components/StyledFlex/src/StyledFlex";
import { StyledLink } from "../../../styled components/StyledLink/src/StyledLink";

const TitleRow = styled(FlexRow)`
    line-height: 1.2;
`;
TitleRow.displayName = "TitleRow";

const StyledIconContainer = styled.div`
    margin-left: 8px;
`;

const InfoIcon = styled(SWReactIcons)`
    line-height: 1.4;
    width: 16px;
    height: 16px;
    display: block;
`;
InfoIcon.displayName = "InfoIcon";

export const TooltipWrapper = styled(NoPrintContainer)`
    margin-left: 8px;
`;

const Icon = styled(SWReactIcons)`
    margin-right: 8px;
    width: 1em;
    height: 1em;
    line-height: 1.4;
    display: block;
`;
Icon.displayName = "Icon";

export interface IBoxTitleProps {
    children: ReactNode;
    tooltip?: string;
    iconName?: IconName;
    href?: string;
    target?: string;
    customElement?: JSX.Element;
    Container?: ComponentType<PropsWithChildren>;
    badge?: BadgeType;
}

const BoxTitle: FC<IBoxTitleProps> = ({
    children,
    tooltip,
    iconName,
    href,
    target,
    customElement,
    Container = TitleRow,
    badge,
}) => {
    return (
        <Container>
            {iconName ? <Icon iconName={iconName} /> : null}
            {href ? (
                <StyledLink
                    href={href}
                    target={target}
                >
                    {children}
                </StyledLink>
            ) : (
                children
            )}
            <Flex
                alignItems="center"
                padding="0 0 0 8px"
            >
                {badge ? <Badge type={badge} /> : null}
            </Flex>
            {tooltip ? (
                <TooltipWrapper>
                    <PlainTooltip
                        placement="top"
                        tooltipContent={tooltip}
                    >
                        <span>
                            <InfoIcon iconName="info" />
                        </span>
                    </PlainTooltip>
                </TooltipWrapper>
            ) : null}
            {customElement ? customElement : null}
        </Container>
    );
};
BoxTitle.displayName = "BoxTitle";
export default BoxTitle;
export { InfoIcon, Icon };
